export default __webpack_public_path__ + "ring-close.f349e57e6cf9106c.svg";